// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__-OY-n","action":"Hero_action__16EqY"};